<template>
  <div ref="background" class="background" @contextmenu.prevent="showContextmenu($event)"
    @click="!$event.defaultPrevented && showNextMessage({ stopAutoPlay: true })"
  >
    <div v-if="loader.loaded && !loader.show">
      <div>
        <v-container
          fluid
          :style="{ display: 'inline-block', height: `100%` }"
          style="padding: 10px;"
        >
          <v-row>
            <v-col class="msg" cols="12">
              <template v-for="(record,i) in displayedHistory">
                <div
                  class="mb-2"
                  :key="i"
                  :style="{ textAlign: record.type === 'user' ? 'right': undefined }"
                >
                  <div class="role-name"
                    :style="{ textAlign: record.type === 'user' ? 'right': undefined }"
                    v-text="record.sender"
                  >
                  </div>
                  <div class="content"
                    :style="{ textAlign: record.type === 'user' ? 'right': undefined }"
                  >
                    <!-- 正常顯示訊息內容 -->
                    <span v-if="!record.taggingResults" v-html="record.content"></span>
                    <!-- 若有 postagging 則以不同的方式顯示 -->
                    <div v-else>
                      <ruby
                        class="postagging"
                        :style="{ backgroundColor: posMap[tagging.pos].color}"
                        v-for="tagging in record.taggingResults"
                        :key="tagging.start">
                        {{tagging.word}}
                        <rp>(</rp>
                        <rt :title="posMap[tagging.pos].title">{{posMap[tagging.pos].symbol ? tagging.word : tagging.pos}}</rt>
                        <rp>)</rp>
                      </ruby>
                    </div>
                  </div>
                </div>
              </template>
              <!-- end history loop -->
              <div
                v-if="history.length > displayedHistory.length"
                style="textAlign:center;"
              >
                <span class="content" style="opacity:0.6; cursor:pointer;">
                  Tap
                </span>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <!-- #Loader -->
    <transition name="fade">
      <v-dialog
        v-model="loader.show"
        hide-overlay
        :persistent="!loader.loaded"
        max-width="300"
      >
        <v-card
          color="secondary"
        >
          <v-card-text class="white--text" style="padding-top: 15px">
            <transition name="fade">
              <div v-if="!loader.loaded">
                <span v-text="loader.text"></span>
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </div>
            </transition>
            <!-- <div style="margin-top: 5px; text-align: center;">
              <v-btn style="opacity: 0.7;" @click="loader.show = false" :disabled="!loader.loaded">
                START
              </v-btn>
            </div> -->
          </v-card-text>
        </v-card>
      </v-dialog>
    </transition>
    <!-- 右鍵選單 -->
    <v-menu
      v-model="contextmenu.show"
      :position-x="contextmenu.x"
      :position-y="contextmenu.y"
      fixed
      offset-y
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <!-- <v-list-item-title>save playback</v-list-item-title> -->
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div> <!-- .background -->
</template>

<script>
import Assistant from '../lib/Assistant'
import Player from '../lib/Player'
import Game from '@/lib/Game'
import * as aitool from '@/lib/ai-tools'
import * as util from '@/lib/util'
import * as gameLoader from '@/lib/loader'
let assistant = Assistant.getInstance()

export default {
  name: 'history-demo',
  components: {
  },
  computed: {
    /**
     * google assistant的預留空間
     */
    assistantHeaderHeight(){
      return this.$store.state.assistantHeaderHeight
    }
  },
  watch: {
  },
  data(){
    return {
      screenplay: null,
      // game: new Game(new Player({ id: 'MAIN' }), assistant),
      /**
       * 已經按下開始按鈕
       * @type {boolean}
       */
      startFlag: false,
      /**
       * 用戶的回覆
       * 會顯示在左下角
       * @type {string}
       */
      userResponseText: '',
      defaultTypeDelay: 70,
      typeDelay: 70,
      writerComplete: false,
      history: [],
      displayedHistory: [],
      // auto play mode
      autoPlayMode: false,
      posMap: null,
      // 會在底下出現的迷你對話窗口
      hint: {
        show: false,
        content: '',
        label: ''
      },
      contextmenu: {
        x: 0,
        y: 0,
        show: false
      },
      loader: {
        text: 'Loading',
        show: true,
        loaded: false
      }
    }
  },
  mounted(){
    this.$store.commit('appbar/setOptions', [
      {
        text: this.$t('HistoryDemo.options.autoPlay.enable'),
        key: 'autoPlay'
      },
      {
        text: this.$t('HistoryDemo.options.complete'),
        key: 'complete'
      }
    ])
    // 會在 beforeDestroy 時註銷
    this.$onAppbarOptionsClick = this.onAppbarOptionsClick.bind(this)
    this.$bus.$on('appbar-option-click', this.$onAppbarOptionsClick)
    gameLoader.loadGameRecord({ recordId: this.$route.params.recordId })
      .then((result)=>{
        if(result.length === 0){
          throw new Error('record not found')
        }
        this.history = result.data
        let len = this.history.length
        if(this.history[len - 1] && this.history[len - 2]){
          if(this.history[len - 1].msgId === this.history[len - 2].msgId){
            this.history.pop()
          }
        }
        if(this.history[0]){
          this.displayedHistory.push(this.history[0])
        }
        this.loader.loaded = true
        this.loader.show = false
      })
      .then(()=>{
        this.fillHistoriesTagging()
      })
      .catch((e)=>{
        console.error(e)
      })
    this.posMap = this.getPosTypeMap()
  },
  beforeDestroy(){
    this.$bus.$off('appbar-option-click', this.$onAppbarOptionsClick)
  },
  methods: {
    onAppbarOptionsClick(option){
      switch(option.key){
        case 'autoPlay':
          if(!this.autoPlayMode){
            this.autoPlay(true)
          }else{
            this.autoPlay(false)
          }
          // 更新選項的顯示文字
          this.$store.commit('appbar/updateOption', {
            key: 'autoPlay',
            update: {
              text: this.$t(`HistoryDemo.options.autoPlay.${this.autoPlayMode ? 'enable' : 'disable'}`)
            }
          })
          this.autoPlayMode = !this.autoPlayMode
          break
        case 'complete':
          for(let i = this.displayedHistory.length; i < this.history.length; i++){
            let message = this.history[i]
            if(!message){
              break
            }
            this.displayedHistory.push(message)
          }
          break
      }
    },
    async showNextMessage(opts = {}){
      let { stopAutoPlay } = opts
      let i = this.displayedHistory.length
      let message = this.history[i]
      if(message){
        this.displayedHistory.push(message)
        await this.playMessageAudio(message)
      }
      if(stopAutoPlay){
        this.autoPlay(false)
      }
    },
    async autoPlay(enable = false){
      if(enable){
        if(!this.$autoPlayMode){
          this.$autoPlayMode = true
          for(let i = this.displayedHistory.length; i < this.history.length; i++){
            if(this.$autoPlayMode){
              await this.showNextMessage()
            }else{
              break
            }
          }
        }
      }else{
        this.$autoPlayMode = false
      }
    },
    async playMessageAudio(){
      // TODO 使用TTS
      return new Promise((resolve)=>{
        setTimeout(resolve, 1000)
      })
    },
    async fillHistoriesTagging(){
      for(let item of this.history){
        this.$set(item, 'taggingResults', null)
      }
      for(let item of this.history){
        try{
          let result = await this.getPostagging(item.content)
          this.$set(item, 'taggingResults', result.items)
          await util.delay(500)
        }catch(e){
          // 若 getPostagging 執行失敗，是因為對應 service 沒有啟動(目前暫時關閉該功能)
          // 所以不須額外處理該錯誤
          console.log('postagging disable')
          break
        }
      }
    },
    getPostagging(content){
      return aitool.postagging(content)
    },
    showContextmenu(event){
      // 暫時不需要右鍵的功能
      // this.contextmenu.show = true
      // this.contextmenu.x = event.clientX + 10
      // this.contextmenu.y = event.clientY - 50
    },
    getPosTypeMap(){
      let typeList = [{ 'type': 'WORK_OF_ART', 'title': '作品' }, { 'type': 'TIME', 'title': '時間' }, { 'type': 'QUANTITY', 'title': '數量' }, { 'type': 'PRODUCT', 'title': '產品' }, { 'type': 'PERSON', 'title': '人物' }, { 'type': 'PERCENT', 'title': '百分比率' }, { 'type': 'ORG', 'title': '組織' }, { 'type': 'ORDINAL', 'title': '序數' }, { 'type': 'NORP', 'title': '民族、宗教、政治團體' }, { 'type': 'MONEY', 'title': '金錢' }, { 'type': 'LOC', 'title': '地理區' }, { 'type': 'LAW', 'title': '法律' }, { 'type': 'LANGUAGE', 'title': '語言' }, { 'type': 'GPE', 'title': '行政區' }, { 'type': 'FAC', 'title': '設施' }, { 'type': 'EVENT', 'title': '事件' }, { 'type': 'DATE', 'title': '日期' }, { 'type': 'CARDINAL', 'title': '數字' }, { 'type': 'WHITESPACE', 'title': '空白' }, { 'type': 'FW', 'title': '外文' }, { 'type': 'SHI', 'title': '是' }, { 'type': 'DE', 'title': '的之得地' }, { 'type': 'V_2', 'title': '有' }, { 'type': 'VL', 'title': '狀態謂賓動詞' }, { 'type': 'VK', 'title': '狀態句賓動詞' }, { 'type': 'VJ', 'title': '狀態及物動詞' }, { 'type': 'VI', 'title': '狀態類及物動詞' }, { 'type': 'VHC', 'title': '狀態使動動詞' }, { 'type': 'VH', 'title': '狀態不及物動詞' }, { 'type': 'VG', 'title': '分類動詞' }, { 'type': 'VE', 'title': '動作句賓動詞' }, { 'type': 'VF', 'title': '動作謂賓動詞' }, { 'type': 'VD', 'title': '雙賓動詞' }, { 'type': 'VCL', 'title': '動作接地方賓語動詞' }, { 'type': 'VC', 'title': '動作及物動詞' }, { 'type': 'VB', 'title': '動作類及物動詞' }, { 'type': 'VAC', 'title': '動作使動動詞' }, { 'type': 'VA', 'title': '動作不及物動詞' }, { 'type': 'T', 'title': '語助詞' }, { 'type': 'P', 'title': '介詞' }, { 'type': 'Nv', 'title': '名物化動詞' }, { 'type': 'Nh', 'title': '代名詞' }, { 'type': 'Ng', 'title': '後置詞' }, { 'type': 'Nf', 'title': '量詞' }, { 'type': 'Neu', 'title': '數詞定詞' }, { 'type': 'Nes', 'title': '特指定詞' }, { 'type': 'Neqb', 'title': '後置數量定詞' }, { 'type': 'Neqa', 'title': '數量定詞' }, { 'type': 'Nep', 'title': '指代定詞' }, { 'type': 'Nd', 'title': '時間詞' }, { 'type': 'Ncd', 'title': '位置詞' }, { 'type': 'Nc', 'title': '地方詞' }, { 'type': 'Nb', 'title': '專有名詞' }, { 'type': 'Na', 'title': '普通名詞' }, { 'type': 'I', 'title': '感嘆詞' }, { 'type': 'DM', 'title': '定量式' }, { 'type': 'Dk', 'title': '句副詞' }, { 'type': 'Di', 'title': '時態標記' }, { 'type': 'Dfb', 'title': '動詞後程度副詞' }, { 'type': 'Dfa', 'title': '動詞前程度副詞' }, { 'type': 'Da', 'title': '數量副詞' }, { 'type': 'D', 'title': '副詞' }, { 'type': 'Cbb', 'title': '關聯連接詞' }, { 'type': 'Cba', 'title': '連接詞，如：的話' }, { 'type': 'Cab', 'title': '連接詞，如：等等' }, { 'type': 'Caa', 'title': '對等連接詞' }, { 'type': 'A', 'title': '非謂形容詞' }, { 'type': 'COLONCATEGORY', 'title': '冒號' }, { 'type': 'COMMACATEGORY', 'title': '逗號' }, { 'type': 'DASHCATEGORY', 'title': '破折號' }, { 'type': 'DOTCATEGORY', 'title': '點號' }, { 'type': 'ETCCATEGORY', 'title': '刪節號' }, { 'type': 'EXCLAMATIONCATEGORY', 'title': '驚嘆號' }, { 'type': 'PARENTHESISCATEGORY', 'title': '括號' }, { 'type': 'PAUSECATEGORY', 'title': '頓號' }, { 'type': 'PERIODCATEGORY', 'title': '句號' }, { 'type': 'QUESTIONCATEGORY', 'title': '問號' }, { 'type': 'SEMICOLONCATEGORY', 'title': '分號' }, { 'type': 'SPCHANGECATEGORY', 'title': '雙直線' }]

      let map = {}
      let hue = 120
      let hueInc = 360 / typeList.length
      for(let item of typeList){
        map[item.type] = {
          color: `hsl(${hue},60%,65%)`,
          symbol: item.type.indexOf('CATEGORY') !== -1,
          title: item.title
        }
        hue += hueInc
        if(hue > 360){
          hue -= 360
        }
      }
      return map
    }
  }
}
</script>
<style>
.vue-typer .custom.char{
  color: white;
}
</style>
<style scoped>
  .h-100{
    height: 100%;
  }
  .background{
    overflow-x: hidden;
    overflow-y: scroll;
    width: 100vw;
    height: 100%;
    background-color: #15202B;
    color: white;
  }
  .msg .role-name{
    font-size: 1rem;
  }
  .user-response{
    font-size: 1rem;
  }
  .msg .content{
    display: inline-block;
    font-size: 1rem;
    padding: 5px;
    border: solid 1px #AAA;
    border-radius: 10px;
    max-width: 70%;
    min-width: 10px;
  }
  .msg .content{
    padding: 12px;
    background-color: #FFAD1F;
    color: #FFF;
    font-weight: bold;
  }
  .msg-hint{
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100vw;
  }
  .msg-hint .hint-content{
    display: inline-block;
    width: 100%;
    padding: 8px;
    /* margin-left: 16px; */
    /* margin-right: 16px; */
    /* min-height: 50px; */
    /* border-radius: 10px; */
    opacity: 0.4;
    background-color: gray;
  }
  .btn-font{
    font-size: 1rem;
  }
  .postagging{
    display: inline-block;
    padding: 5px;
    margin-right: 3px;
    margin-top: 5px;
    border-radius: 10px;
    border: 1px solid rgba(100, 100, 100, 0.1);
  }
  .postagging *{
    text-align: center;
  }
</style>
